export const SETTING_OPTIONS = () => {
  return {
    flow: {
      key: "flow",
      options: {
        option1Text: "m³/h",
        option2Text: "m³/d",
        option3Text: "gpm",
      },
    },
    mass: {
      key: "mass",
      options: {
        option1Text: "kg",
        option2Text: "lb",
      },
    },
    feed_suspended: {
      key: "feed_suspended",
      options: {
        option1Text: "NTU",
        option2Text: "TSS",
        option3Text: "SDI",
      },
    },
    pressure: {
      key: "pressure",
      options: {
        option1Text: "bar",
        option2Text: "psig",
      },
    },
    flux: {
      key: "flux",
      options: {
        option1Text: "lmh",
        option2Text: "gfd",
      },
    },
    filtrate_suspended: {
      key: "filtrate_suspended",
      options: {
        option1Text: "NTU",
        option2Text: "TSS",
        option3Text: "SDI",
      },
    },
    volume: {
      key: "volume",
      options: {
        option1Text: "m³",
        option2Text: "kgal",
      },
    },
    temperature: {
      key: "temperature",
      options: {
        option1Text: "C",
        option2Text: "F",
      },
    },
    currency: {
      key: "currency",
      options: {
        option1Text: "USD",
        option2Text: "Yuan",
        option3Text: "Euro",
      },
    },
  };
};

export const Currency_Conversion_Mapping = {
  USD: 1,
  Yuan: 7.17,
};
export const Language_Currency_Mapping = {
  en: "USD",
  zh: "Yuan",
};
export const Default_Currency_Rate = {
  USD: 1,
  Yuan: 7.17,
};
